export const getMounted = state=>state.mounted;

export const getScreenSize = state =>state.screenSize;

export const getUser = state=> state.user;



export const getActiveDays = state =>{
    return state.activeDays;
}

export const getSelectedDayHours = state =>{
    return state.selectedDayHours;
}

export const getSelectedHour = state => state.selectedHour;
export const getSelectedDay = state => state.selectedDay;
export const getSidebarVisible = state => state.sidebarVisible;

export const getStatus = state => state.status;

export const getSelectedInterval = state => state.selectedInterval;

export const getRealtimeEnabled = state => state.realtimeEnabled; 

export const getLocalSettings = state => state.localSettings;
export const getLanguage = state => {
    if (state.localSettings.interface)
        return state.localSettings.interface.language;
    return "en";
 }
export const getUnsavedLocalSettings = state => state.unsavedLocalSettings;


/*SETTINGS */
export const getSettings = state => state.settings;

//Alert messaging
export const getSettingsAlertMessaging = state =>{
    if(state.settings.alerts) 
        return state.settings.alerts;
    return {};
}
//Audio
export const getSettingsAudioRecording = state =>{
    if(state.settings.audio) 
        return state.settings.audio;
    return {};
}
//Delete
export const getSettingsDelete = state =>{
    if(state.settings.delete) 
        //return state.settings.delete; //ne najdem
    return {};
}
//Device
export const getSettingsDevice = state =>{
    if(state.settings.device) 
        return state.settings.device;
    return {};
}
//Download
export const getSettingsDownload = state =>{
    if(state.settings.download) 
        return state.settings.download;
    return {
        downloadValues:{},
        downloadwValues:{},
        globalValues:{}
    };
}
//DNS
export const getSettingsDynamicDNS = state =>{
    if(state.settings.dyndns) 
        return state.settings.dyndns;
    return {};
}
//FTP
export const getSettingsFTPSending = state =>{
    if(state.settings.ftp) 
        return state.settings.ftp;
    return {
        valuesValues:{}
    };
}
//GPS
export const getSettingsGeographicalPosition = state =>{
    if(state.settings.gps) 
        return state.settings.gps;
    return {};
}
//Interface
export const getSystemStatus = state => state.systemStatus;
export const getFirmware = state => state.firmware; //ADDED

export const getSettingsInterface = state =>{
    if(state.unsavedLocalSettings.interface) 
        return state.unsavedLocalSettings.interface;
    return {};
}
//Addons
export const getSettingsAddons = state =>{
    if(state.settings.addons)
        return state.settings.addons;
    return {};
}
//Weather
export const getSettingsWeather = state =>{
    if(state.settings.weather) 
        return state.settings.weather;
    return {
        valselValues:{}
    };
}
//System
export const getSettingsSystem = state =>{
    if(state.settings.system)
        return state.settings.system;
    return {}
}

export const getSettingsUsers = state =>{
    if (state.settings.users)
        return state.settings.users;
    return {};
}

//Specvall
export const getSettingsSpecval = state =>{
    if(state.settings.specval)
        return state.settings.specval;
    return {};
}

export const getSettingsVideo = state =>{
    return state.settings.video;
}

export const getSettingsAdio = state=>{
    return state.settings.adio;
}

export const getSettingsNorCloud = state=>{
    return state.settings.norcloud;
}   


export const getSettingsEmail = state=>{
    return state.settings.email;
}

export const getSettingsStatistics = state =>{
    return state.settings.statistics;
}

export const getSettingsStartstop = state =>{
    return state.settings.startstop;
}
export const getDownloading = state => {
    return state.isDownloading;
}


// WEBPACK FOOTER //
// ./src/store/getters.js